import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useCreatePortfolioCategory = () => {
  const mutation = trpc.portfolioManagement.categories.create.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, createCategory: action.execute };
};
